import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { environment } from "../../../environments/environment";
import { Subject } from "rxjs";

import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-delete-item-confirmation-dialog",
  templateUrl: "./delete-item-confirmation-dialog.component.html",
  styleUrls: ["./delete-item-confirmation-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteItemConfirmationDialogComponent
  extends MzBaseModal
  implements OnInit {
  readonly env: any = environment;
  private resultSubject: Subject<boolean>;

  @Input() message: string = "Willst Du das gewählte Item wirklich löschen?";
  @Input() cancelButtonText: string = "Abbrechen";
  @Input() confirmButtonText: string = "Löschen";

  constructor(private toastService: MzToastService) {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  onDeleteFeatureClicked() {
    this.resultSubject.next(true);
    this.resultSubject.complete();
  }

  async getResultAsync() {
    this.modalComponent.open();
    this.resultSubject = new Subject<boolean>();
    return this.resultSubject.first().toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/delete-item-confirmation-dialog/delete-item-confirmation-dialog.component.ts